/* eslint-disable import/prefer-default-export */
import { isEmpty, lensPath, reject, view } from 'ramda';
export const arrayToString = (array) => {
    array = reject(isEmpty, array);
    if (array.length > 0) {
        return array.join();
    }
    else {
        return '';
    }
};
export const sortAscendingFn = (a, b) => a - b;
export const first = (arr) => arr[0];
export const last = (arr) => arr[arr.length - 1];
export const getSequentialNumbersArray = (start, end) => {
    const arr = [];
    for (let i = start; i <= end; i++) {
        arr.push(i);
    }
    return arr;
};
export const getSortArrayByObjectsPropertyValuesFn = (propertyKey) => (a, b) => {
    const fa = a[propertyKey].toLowerCase();
    const fb = b[propertyKey].toLowerCase();
    if (fa < fb) {
        return -1;
    }
    if (fa > fb) {
        return 1;
    }
    return 0;
};
export const sortArrayByObjectsPropertyValues = (arr, propertyKey) => {
    return arr.sort(getSortArrayByObjectsPropertyValuesFn(propertyKey));
};
export const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
        result.push(i);
    }
    return result;
};
export const arrayToKeyMap = (arr = [], stringNumToNumber = false, initialPropValue = Symbol('Such key exists')) => {
    const keyMap = {};
    arr.forEach((el) => {
        keyMap[stringNumToNumber ? +el : el] = initialPropValue;
    });
    return keyMap;
};
export const arrayToMap = (keyProp, arr = []) => {
    const map = new Map();
    arr.forEach((el) => {
        map.set(el[keyProp], el);
    });
    return map;
};
export const sortTree = (tree, sortProperty, childrenProperty = 'children') => {
    tree = tree.sort((a, b) => {
        const fa = a[sortProperty].toLowerCase();
        const fb = b[sortProperty].toLowerCase();
        if (fa < fb) {
            return -1;
        }
        if (fa > fb) {
            return 1;
        }
        return 0;
    });
    tree.forEach((el) => {
        if (el[childrenProperty]) {
            el[childrenProperty] = sortTree(el[childrenProperty], sortProperty, childrenProperty);
        }
    });
    return tree;
};
export const mergeWithNestedObjectsReplace = (oldArr, newArr, keyPropPath) => {
    const result = [...oldArr];
    newArr.forEach((el) => {
        const path = lensPath([...keyPropPath.split('.')]);
        const index = result.findIndex((item) => view(path, item) === view(path, el));
        if (index !== -1) {
            result[index] = el;
        }
        else {
            result.push(el);
        }
    });
    return result;
};
export const mergeWithNestedObjectsMerge = (arr1, arr2, keyPropPath) => {
    const result = [...arr1];
    arr2.forEach((el) => {
        const path = lensPath([...keyPropPath.split('.')]);
        const index = result.findIndex((item) => view(path, item) === view(path, el));
        if (index !== -1) {
            result[index] = { ...result[index], ...el };
        }
        else {
            result.push(el);
        }
    });
    return result;
};
export const findIntersection = (...arrays) => {
    const [firstArr, ...rest] = arrays;
    const firstArrMap = arrayToKeyMap(firstArr || []);
    const otherArraysMaps = rest.map((arr) => arrayToKeyMap(arr));
    const intersection = [];
    Object.keys(firstArrMap).forEach((key) => {
        if (otherArraysMaps.every((map) => map[key])) {
            intersection.push(key);
        }
    });
    return intersection;
};
export function findIntersectionOfObjectsByKey(key, ...arrays) {
    const maps = arrays?.map((array) => arrayToMap(key, array)) || [];
    const result = [];
    maps[0]?.forEach((value, _key) => {
        if (maps.slice(1).every((map) => map.has?.(_key))) {
            result.push(value);
        }
    });
    return result;
}
